<template>
	<el-dialog class="agreeDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				岱屿画境AI创作平台用户服务协议
			</div>
		</div>
		<div class="dislogConent">
			<div>
				在创意无限、技术革新的数字时代，有这样一个平台脱颖而出，成为众多创作者心中的灵感源泉与得力助手。它宛如一座创意的百宝城，网罗了从写实到二次元、从插画到 3D
				建模等多种类型的创作工具，为创作者们搭建起一个多元且全面的创作舞台。
				对于钟情于传统写实风格的创作者而言，平台提供的工具宛如细腻的画笔与精准的调色盘，能让每一处光影、每一抹色彩都精准地呈现在画布之上，逼真还原现实场景。而二次元爱好者们，则能借助专门的工具，轻松勾勒出风格各异的动漫角色，无论是萌系少女、热血少年，还是奇幻场景，都能在笔下栩栩如生。插画领域更是百花齐放，从清新的手绘风插画，到时尚的矢量插画，创作者们可凭借丰富的画笔预设、便捷的图层管理等功能，将脑海中的奇思妙想快速转化为精美的插画作品。在
				3D 建模方面，平台集成了一系列强大的工具，从基础的多边形建模，到复杂的曲面建模，再到材质纹理的精细编辑与逼真渲染，全方位满足 3D 创作者从概念设计到最终成品的每一个环节需求。 在 AI
				绘画浪潮汹涌的当下，平台还贴心地为创作者们推荐了一系列 AI 绘画学习的优质教程网站。这些网站如同良师益友，从 AI
				绘画软件的基础操作开始讲解，逐步深入到提示词的精妙运用、模型的选择与优化等进阶技巧。无论是零基础小白，还是有一定经验的创作者，都能从中找到适合自己的学习路径，快速掌握 AI
				绘画这一新兴创作方式，拓宽自己的创意边界。
				同时，平台深知创作过程中素材的重要性，因而整合了众多常用设计素材库。从高清精美的图片素材，到风格多样的矢量图形；从丰富的字体资源，到实用的图标库，应有尽有。这些素材不仅类型丰富，而且在版权方面也有着严格的把控与清晰的说明，部分素材可直接用于商业用途，让创作者们无需为版权问题而担忧，能够全身心投入到创作之中。
				不仅如此，平台还致力于为高阶创作者提供进阶创作模型。在 3D 建模领域，有针对复杂角色动画的骨骼系统模型、用于创建逼真自然环境的生态系统模型等；在 AI
				绘画方面，提供了风格独特的定制化模型，创作者可以根据自己的创作风格偏好，对模型进行微调，从而生成更具个人特色的作品。这些进阶创作模型，犹如创作路上的秘密武器，助力创作者们突破创作瓶颈，迈向更高的艺术境界。
				这个平台就像一个充满活力的创意社区，汇聚了各类创作人才，为每一位怀揣创作梦想的人提供了丰富的工具、学习资源与创作素材。无论你是初出茅庐的新手，还是经验丰富的行业大咖，都能在这里找到属于自己的创作天地，开启无限可能的创作之旅。
				在创意无限、技术革新的数字时代，有这样一个平台脱颖而出，成为众多创作者心中的灵感源泉与得力助手。它宛如一座创意的百宝城，网罗了从写实到二次元、从插画到 3D
				建模等多种类型的创作工具，为创作者们搭建起一个多元且全面的创作舞台。
				对于钟情于传统写实风格的创作者而言，平台提供的工具宛如细腻的画笔与精准的调色盘，能让每一处光影、每一抹色彩都精准地呈现在画布之上，逼真还原现实场景。而二次元爱好者们，则能借助专门的工具，轻松勾勒出风格各异的动漫角色，无论是萌系少女、热血少年，还是奇幻场景，都能在笔下栩栩如生。插画领域更是百花齐放，从清新的手绘风插画，到时尚的矢量插画，创作者们可凭借丰富的画笔预设、便捷的图层管理等功能，将脑海中的奇思妙想快速转化为精美的插画作品。在
				3D 建模方面，平台集成了一系列强大的工具，从基础的多边形建模，到复杂的曲面建模，再到材质纹理的精细编辑与逼真渲染，全方位满足 3D 创作者从概念设计到最终成品的每一个环节需求。 在 AI
				绘画浪潮汹涌的当下，平台还贴心地为创作者们推荐了一系列 AI 绘画学习的优质教程网站。这些网站如同良师益友，从 AI
				绘画软件的基础操作开始讲解，逐步深入到提示词的精妙运用、模型的选择与优化等进阶技巧。无论是零基础小白，还是有一定经验的创作者，都能从中找到适合自己的学习路径，快速掌握 AI
				绘画这一新兴创作方式，拓宽自己的创意边界。
				同时，平台深知创作过程中素材的重要性，因而整合了众多常用设计素材库。从高清精美的图片素材，到风格多样的矢量图形；从丰富的字体资源，到实用的图标库，应有尽有。这些素材不仅类型丰富，而且在版权方面也有着严格的把控与清晰的说明，部分素材可直接用于商业用途，让创作者们无需为版权问题而担忧，能够全身心投入到创作之中。
				不仅如此，平台还致力于为高阶创作者提供进阶创作模型。在 3D 建模领域，有针对复杂角色动画的骨骼系统模型、用于创建逼真自然环境的生态系统模型等；在 AI
				绘画方面，提供了风格独特的定制化模型，创作者可以根据自己的创作风格偏好，对模型进行微调，从而生成更具个人特色的作品。这些进阶创作模型，犹如创作路上的秘密武器，助力创作者们突破创作瓶颈，迈向更高的艺术境界。
				这个平台就像一个充满活力的创意社区，汇聚了各类创作人才，为每一位怀揣创作梦想的人提供了丰富的工具、学习资源与创作素材。无论你是初出茅庐的新手，还是经验丰富的行业大咖，都能在这里找到属于自己的创作天地，开启无限可能的创作之旅。
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.agreeDialog {

		::v-deep .el-dialog {
			width: 8rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				height: 5rem;
				overflow-y: auto;
				padding: 0 .24rem .24rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
			}
		}
	}
</style>